import { ExtraCard } from "@/components/ExtraCard/ExtraCard.tsx";
import { ExtrasGridProps } from "@/components/ExtrasGrid/ExtrasGridProps.ts";
import { VehicleNote } from "@/components/ReservationOptions/VehicleNote/VehicleNote.tsx";
import { PlusCircle, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ExtrasGrid = ({ optionalExtras, mandatoryExtras, cartItem }: ExtrasGridProps) => {
  const { t } = useTranslation();

  const hasOptional = optionalExtras?.length > 0;
  const hasMandatory = mandatoryExtras?.length > 0;
  const isParcel = cartItem?.rateGroup?.isParcel;

  if (!hasOptional && !hasMandatory) {
    if (isParcel) {
      return (
        <div className="c-extras-grid">
          <VehicleNote cartItem={cartItem} />
          <p className="c-extras-grid__no-extras">{t("noExtrasAvailable")}</p>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="c-extras-grid">
      <VehicleNote cartItem={cartItem} />
      <div className="c-extras-grid__columns">
        {hasOptional && (
          <div className="c-extras-grid__column">
            <h3 className="c-extras-grid__header u-h6 u-fw-600">
              <PlusCircle size={20} className="c-extras-grid__header-icon" />
              {t("optionalExtras")}
            </h3>
            <div className="c-extras-grid__list">
              {optionalExtras?.map((extra) => <ExtraCard key={extra.id} extra={extra} cartItem={cartItem} />)}
            </div>
          </div>
        )}
        {hasMandatory && (
          <div className="c-extras-grid__column">
            <h3 className="c-extras-grid__header u-h6 u-fw-600">
              <ShieldCheck
                size={20}
                className="c-extras-grid__header-icon c-extras-grid__header-icon--muted"
              />
              {t("mandatoryExtras")}
            </h3>
            <div className="c-extras-grid__list">
              {mandatoryExtras?.map((extra) => (
                <ExtraCard key={extra.id} extra={extra} cartItem={cartItem} isMandatory />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
